// const BASE_URL = 'https://www.geonames.org';
// const BRAZIL_GEONAME_ID = '3469034';

const baseUrl = process.env.VUE_APP_API_URL || '';

const defaultHeaders = {
  'Accept': 'application/json',
  'Content-Type': 'application/json;charset=UTF-8'
};

export async function listBrazilianStatesNamesAsync(withTherapistsOnly = false) {
  const response = await fetch(`${baseUrl}/api/geolocation/brazilian-states?with-therapists-only=${withTherapistsOnly}`, {
    headers: defaultHeaders,
    method: 'GET'
  });

  if (response.ok) {
    const stateNames = await response.json();
    return stateNames.map(sn => ({text: sn, value: sn}));
  }
  
  throw new Error(await response.text())
}

export async function listBrazilianCitiesNamesAsync(stateName, withTherapistsOnly = false) {
  const response = await fetch(`${baseUrl}/api/geolocation/${stateName}/cities?with-therapists-only=${withTherapistsOnly}`, {
    headers: defaultHeaders,
    method: 'GET'
  });

  if (response.ok) {
    const stateNames = await response.json();
    return stateNames.map(sn => ({text: sn, value: sn}));
  }
    
  throw new Error(await response.text())
}


export default {
  listBrazilianStatesNamesAsync,
  listBrazilianCitiesNamesAsync,
}